export enum transitionStates {
    preVisible = 'page-transition-preVisible',
    visible = 'page-transition-visible',
    postVisible = 'page-transition-postVisible',
}

// Also referenced in globals.scss
export const pageTransitionTime = 1000;
